import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import MainLoader from "./components/MainLoader/MainLoader";
import Login from "./screens/Login/Login";
import CreateUser from "./screens/CreateUser/CreateUser";
import Information from "./screens/Information/Information";
import ModifyUser from "./screens/ModifyScreen/ModifyUser";
import CustomerSummary from "./screens/Summary/CustomerSummary";
import Planning from "./screens/VkPlanning/Planning";
import PrivateRoutes from "./components/PrivateRouter/PrivateRoutes";
import ChooseTemplate from "./screens/Template/ChooseTemplate/ChooseTemplate";
import TemplatesNew from "./screens/Template/Template_new";
import EkPlanning from "./screens/EkPlanning/EkPlanning";
import Refill from "./screens/Refill/Refill";
import "./utility/axiosInterceptor";
// 
import { useDispatch } from "react-redux";
import { clearSelectedCustomerDetail } from "./slices/customerSlice";
import { toast } from "react-toastify";

function App() {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const location = useLocation(); //  current path


  useEffect(() => {
    if (location.pathname === "/") return;

    const checkExpiry = () => {
      const expiresAt = Number(localStorage.getItem("planningLock"));
      // console.log("date", Date.now())
      // console.log("expiresAt", expiresAt)

      if (!expiresAt) return;

      if (Date.now() >= expiresAt) {
        dispatch(clearSelectedCustomerDetail());
        toast.success("Lock expired.");
      }
    };

    checkExpiry();

    const interval = setInterval(checkExpiry, 1000);

    return () => clearInterval(interval);
  }, [dispatch, location.pathname]);


  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1800);

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);

  if (loading) {
    return <MainLoader />;
  }







  return (
    <div className="App">
      <ToastContainer />
      <Routes>
        <Route element={<PrivateRoutes />}>
          <Route path="/create-user" element={<CreateUser />} />
          <Route path="/information" element={<Information />} />
          <Route path="/modify-user" element={<ModifyUser />} />
          <Route path="/customer-summary" element={<CustomerSummary />} />
          <Route path="/vk-planning" element={<Planning />} />
          <Route path="/vk-planning/:customerID/:shipTo/:year/:div/:city/:customerName/:vtr/:isEditable" element={<Planning />} />
          <Route path="/template" element={<ChooseTemplate />} />
          <Route path="/newScreen-templateN" element={<TemplatesNew />} />
          {/* <Route path="/newScreen-template/:customerID" element={<Template />} /> */}
          <Route path="/newScreen-templateN/:soldTo/:division/:planYear" element={<TemplatesNew />} />
          <Route path="/ek-planning" element={<EkPlanning />} />
          <Route path="/ek-planning/:customerID" element={<EkPlanning />} />
          <Route path="/re-fill" element={<Refill />} />

        </Route>
        <Route path="/" element={<Login />} />
      </Routes>
    </div>
  );
}

export default App;
